<form>
    @for (bundleOption of bundleOptions; track $index) {
    <h6 class="p-b-1 m-t-2 fs-4">{{bundleOption.option.title}}</h6>
    @for (child of bundleOption.children; track $index) {
    @if (child.product) {
    <div class="m-t-2">
        <button class="cursor-pointer"
                [ngClass]="{'fw-bold': bundleOption.isPicked(child), 'is-disabled': !child.product || child.product.isOutOfStock}"
                role="button"
                (click)="bundleOption.toggle(child)">
            {{child.product?.data?.name}}
        </button>
    </div>
    }
    }
    <div class="m-t p-b uppercase fs-4 cursor-pointer"
         [ngClass]="{'fw-bold underline': !bundleOption.hasSelection}"
         (click)="bundleOption.removeAll()">
        {{'reset selection' | translate}}
    </div>
    }
</form>
